// Ficha de producto: el bloque "Info de entrega y métodos de pago" viene pegado
// en la descripción de ~56 productos (en ~21 variantes de redacción). En vez
// de editar cada producto, se lo saca de la descripción y se lo muestra en un
// popup (<dialog>) que abre un link. Todo lo que está desde ese título hasta el
// final de la descripción va al popup; lo de antes queda como estaba.
(function () {
  var TITULO = /info de entrega/i;

  function iniciar() {
    var descripciones = document.querySelectorAll('.product-single__description');
    // Puede haber descripciones anidadas (HTML pegado): se usa la más externa.
    var desc = descripciones[0];
    if (!desc || desc.dataset.paniInfo) return;

    var walker = document.createTreeWalker(desc, NodeFilter.SHOW_TEXT);
    var nodo, inicio = null;
    while ((nodo = walker.nextNode())) {
      if (TITULO.test(nodo.textContent)) { inicio = nodo; break; }
    }
    if (!inicio) return;
    desc.dataset.paniInfo = '1';

    // Se sube mientras el ancestro empiece con el título: así se mueve el
    // bloque completo sin arrastrar descripción del producto que esté antes.
    var ancla = inicio;
    while (ancla.parentNode && ancla.parentNode !== desc &&
           ancla.parentNode.textContent.trim().search(TITULO) === 0) {
      ancla = ancla.parentNode;
    }

    // Todo lo que sigue en orden de documento dentro de la descripción: un
    // Range del título al final lo extrae entero, partiendo bien los
    // contenedores que quedan a medias (el HTML pegado varía mucho).
    var rango = document.createRange();
    rango.setStartBefore(ancla);
    rango.setEndAfter(desc.lastChild);
    var extraido = rango.extractContents();

    var dialogo = document.createElement('dialog');
    dialogo.className = 'pani-info';
    dialogo.setAttribute('aria-labelledby', 'pani-info-titulo');
    dialogo.innerHTML =
      '<div class="pani-info__caja">' +
        '<button type="button" class="pani-info__cerrar" aria-label="Cerrar">&times;</button>' +
        '<p class="pani-info__antetitulo">PANI</p>' +
        '<h2 id="pani-info-titulo" class="pani-info__titulo">Info de entrega y métodos de pago</h2>' +
        '<div class="pani-info__contenido rte"></div>' +
      '</div>';
    var contenido = dialogo.querySelector('.pani-info__contenido');
    contenido.appendChild(extraido);

    // El título original queda repetido arriba del contenido: se saca.
    var walker2 = document.createTreeWalker(contenido, NodeFilter.SHOW_TEXT);
    var t;
    while ((t = walker2.nextNode())) {
      if (TITULO.test(t.textContent)) {
        var contenedor = t.parentNode;
        t.textContent = t.textContent.replace(/info de entrega y m[eé]todos de pago:?/i, '').trim();
        if (contenedor && !contenedor.textContent.trim() && contenedor !== contenido) {
          var siguiente = contenedor.nextSibling;
          if (siguiente && siguiente.nodeName === 'BR') siguiente.remove();
          contenedor.remove();
        }
        break;
      }
    }

    // En el original los ítems (💳, 🎁, 📅…) van separados solo por <br>:
    // se les da aire para que se lean como párrafos.
    contenido.querySelectorAll('br').forEach(function (br) {
      var sep = document.createElement('span');
      sep.className = 'pani-info__sep';
      br.replaceWith(sep);
    });

    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'pani-info__abrir';
    boton.innerHTML = '<span aria-hidden="true">&#9993;</span> Info de entrega y métodos de pago <span aria-hidden="true">&rsaquo;</span>';
    desc.appendChild(boton);
    document.body.appendChild(dialogo);

    function cerrar() {
      dialogo.classList.add('pani-info--cerrando');
      setTimeout(function () { dialogo.classList.remove('pani-info--cerrando'); dialogo.close(); }, 200);
    }
    boton.addEventListener('click', function () { dialogo.showModal(); });
    dialogo.querySelector('.pani-info__cerrar').addEventListener('click', cerrar);
    // Clic fuera de la caja (en el fondo oscuro) cierra.
    dialogo.addEventListener('click', function (e) { if (e.target === dialogo) cerrar(); });
    dialogo.addEventListener('cancel', function (e) { e.preventDefault(); cerrar(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
